// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__bv16B","content":"Footer_content__EyWJb","coffee":"Footer_coffee__TWWdE","credits":"Footer_credits__p67KO"};